import React from "react";
import { Label } from "./label";

const RequiredLabel = ({ htmlFor, children, className = "" }) => {
  return (
    <Label htmlFor={htmlFor} className={className}>
      {children} <span className="text-red-500">*</span>
    </Label>
  );
};

export default RequiredLabel;
